import PropTypes from "prop-types"
import {styled} from "@mui/material"
import React, {useCallback} from "react"

const ButtonSelectWidgetChild = styled("div", {
    shouldForwardProp: (prop) => prop !== "isSelected",
})(({theme, isSelected}) => theme.BUTTONSELECTWIDGET.child(theme, isSelected))

const Icon = styled("div", {
    shouldForwardProp: (prop) => prop !== "isSelected",
})(({theme, isSelected}) => theme.BUTTONSELECTWIDGET.icon(theme, isSelected))

const ButtonSelectWidgetItem = ({
                                    isSelected,
                                    onClick,
                                    value,
                                    label,
                                }) => {
    const localOnClick = useCallback(
        () => onClick(value),
        [onClick, value],
    )

    return <ButtonSelectWidgetChild isSelected={isSelected}
                                    onClick={localOnClick}
                                    role="button">
        <Icon isSelected={isSelected} />
        {label}
    </ButtonSelectWidgetChild>
}

ButtonSelectWidgetItem.propTypes = {
    isSelected: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    value: PropTypes.any.isRequired,
    label: PropTypes.string.isRequired,
}

export default ButtonSelectWidgetItem